//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Object.js";
import "../MechanicalRouting/MechanicalRouting.RoutingManager.js";
let d=[[],[[["collaborativeDesign","runIdsToLoad"],"LoadRuns",{},2,0],[["run"],"UnloadRun",{},1,0],[["numberOfRuns","runs"],"GetLoadedRuns",{},0,0],[["part","run"],"AssociateRun",{},2,0],[["part","run"],"DissociateRun",{},2,0],[["part","run"],"SetActiveRun",{},2,0],[["part"],"MakeRunInactive",{},1,0],[["component","run"],"AddToRun",{},2,0],[["componentsToAdd","run"],"AddComponentsToRun",{},2,0],[["component","run"],"RemoveComponentFromRun",{},2,0],[["componentsToRemove","run"],"RemoveComponentsFromRun",{},2,0],[["component","run"],"MoveToRun",{},2,0],[["componentsToMove","run"],"MoveComponentsToRun",{},2,0],[["part","runObject"],"Delete3dRunObject",{},2,0],[["part","run"],"ShowFlowDirectionForRun",{},2,0],[["part","run"],"ShowFlowDirectionForRunBranch",{},2,0],[["run"],"ReverseFlowDirectionForRunBranch",{},1,0],[["runObjects"],"Delete3dRunObjects",{},1,0]],[]];
SPLM.MechanicalRouting.RunsManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.MechanicalRouting.RunsManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;